import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {Calendar} from "primereact/calendar";
import {InputMask} from "primereact/inputmask";
import moment from "moment/moment";
import {InputSwitch} from "primereact/inputswitch";
import {AutoComplete} from "primereact/autocomplete";

const ContactpartnerFormComponent = (props) => {

  const {t, partnerId, contactId} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  
  const [partnerQuery, setPartnerQuery] = useState(
    window.App.urlVars().partnerName ? decodeURIComponent(window.App.urlVars().partnerName) : ''
  );
  const [partnerLoading, setPartnerLoading] = useState(false);
  const [partners, setPartners] = useState([]);

  const [contacts, setContacts] = useState([]);
  const [saveAndBack, setSaveAndBack] = useState(false);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };

  const getBacklink = () => {
    if (props.backlink) {
      return props.backlink;
    }
    if (contactId || window.App.urlVars().contactId) {
      return '/partner/contact?read=contact&contactId=' + (contactId || window.App.urlVars().contactId);
    }
    if (partnerId || id) {
      return '/partner/read/' + (partnerId || id);
    }
    return '/partner/contact';
  };

  const onSubmit = (data, form) => {
    const payload = {
      partner: formData?.partner?.id || formData.partner || partnerId || null,
      position: formData.position || null,
      date_from: formData.date_from || null,
      date_until: formData.date_until || null,
      contact: contactId || formData?.contact?.id || formData.contact || null,
      active: !!formData.active
    };
    setLoading(true)
    if ((window.App.urlVars().contactPartnerId) || (entity === 'contactpartner' && id)) {
      apiCall('patch', '/api/v2/contact-partner/' + (window.App.urlVars().contactPartnerId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({
            rerenderContactpartnerList: Math.random(),
            rerenderContactList: Math.random()
          })
          if (saveAndBack || props.goback === true) {
            history.push(getBacklink());
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/contact-partner', payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({
            rerenderContactpartnerList: Math.random(),
            rerenderContactList: Math.random()
          })
          history.push(props.backlink);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    setPartnerQuery(q);
    if (q.length < 2) {
      setPartners([]);
      return;
    }
    setPartnerLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/partner", {
      params: {
        rows: 15,
        'search[name][operator]': 'like',
        'search[name][value]': `%${q}%`,
        'search[customer][operator]': '==',
        'search[customer][value]': 'true'
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map((partner) => ({
          ...partner,
          displayName:
            partner.name +
            (
              partner.address_postal_code || partner.address_city || partner.address_detail
                ? ` (${partner.address_postal_code || ''} ${partner.address_city || ''}, ${partner.address_detail || ''})`
                : ''
            )
        }));
        setPartners(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setPartnerLoading(false);
      });
  };

  useEffect(() => {
    const partnerId = window.App.urlVars().partnerId;
    const partnerName = window.App.urlVars().partnerName;
    if (partnerId && partnerName) {
      setFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setNewFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setPartnerQuery(decodeURIComponent(partnerName));
    }
  }, [window.location.hash]);

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().contactPartnerId) || (entity === 'contactpartner' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/contact-partner/' + (window.App.urlVars().contactPartnerId ?? id))
        .then(response => {
          const data = response.data.data;
          setFormData(data);
          if (data?.partner) {
            const partnerDisplayName = data.partner.name;
            setPartnerQuery(partnerDisplayName);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    apiCall('get', '/api/v2/contact')
      .then(response => {
        const items = response?.data?.data?.items || [];
        setContacts(items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [])

  return (
    <div className={"contactpartner-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="position" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="position"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPosition')}</label>
                  <span className="p-d-block">
                      <InputText id="position" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     position: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     position: e.target.value
                                   })
                                 }}
                                 value={formData.position}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <Field name="date_from" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="date_from"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDateFrom')}</label>
                  <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"date_from"}
                                        mask={"9999-99-99"}
                                        placeholder={t('datePlaceholder')}
                                        value={formData.date_from}
                                        onChange={(e) => {
                                          if (e.value.indexOf("_") === -1) {
                                            if (e.value === '') {
                                              e.value = null
                                            }
                                            setFormData({
                                              ...formData,
                                              date_from: e.value
                                            })
                                          }
                                        }}
                            />
                            <Calendar value={formData.date_from}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date_from: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                      }}/>
                          </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <Field name="date_until" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="date_until"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDateTo')}</label>
                  <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                          <InputMask id={"date_until"}
                                      mask={"9999-99-99"}
                                      placeholder={t('datePlaceholder')}
                                      value={formData.date_until}
                                      onChange={(e) => {
                                        if (e.value.indexOf("_") === -1) {
                                          if (e.value === '') {
                                            e.value = null
                                          }
                                          setFormData({
                                            ...formData,
                                            date_until: e.value
                                          })
                                        }
                                      }}
                          />
                            <Calendar value={formData.date_until}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date_until: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                      }}/>
                          </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"} id="partner">
              <Field name="partner" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="partner" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPartner')}</label>
                  <span className={"p-field p-inputgroup"}>
                      <Button type="button" className={"p-button"}
                              onClick={() => {
                                const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                const currentVars = window.App.urlVars();
                                const nextParams = new URLSearchParams();
                                Object.entries(currentVars).forEach(([key, value]) => {
                                    if (key !== 'formData' && key !== 'search') {
                                        nextParams.append(key, value);
                                    }
                                });
                                nextParams.append('formData', JSON.stringify(formData));
                                nextParams.append('backlink', window.location.hash.replace('#', ''));
                                nextParams.append('search', 'partner');
                                history.push(currentPath + '?' + nextParams.toString());
                              }}>
                        <i className={"pi pi-search"}></i>
                      </Button>
                      <AutoComplete
                                    value={partnerQuery}
                                    id={"partner"}
                                    loading={partnerLoading}
                                    suggestions={partners}
                                    forceSelection
                                    completeMethod={searchPartner}
                                    field={"displayName"}
                                    delay={700}
                                    placeholder={t('typeToSearchPlaceholder')}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                    onSelect={(e) => {
                                      const p = e.value;
                                      if (!p?.id) return;
                                      setPartnerQuery(p.displayName || p.name || '');
                                      setFormData(prev => ({
                                        ...prev,
                                        partner: Number(p.id)
                                      }));
                                      setNewFormData(prev => ({
                                        ...prev,
                                        partner: Number(p.id)
                                      }));
                                    }}
                                    onChange={(e) => {
                                      setPartnerQuery(e.value);
                                      if (!e.value || String(e.value).trim() === '') {
                                        setFormData(prev => ({
                                          ...prev,
                                          partner: null
                                        }));
                                        setNewFormData(prev => ({
                                          ...prev,
                                          partner: null
                                        }));
                                      }
                                    }}
                                    onClear={() => {
                                      setPartnerQuery('');
                                      setFormData(prev => ({
                                        ...prev,
                                        partner: null
                                      }));
                                      setNewFormData(prev => ({
                                        ...prev,
                                        partner: null
                                      }));
                                    }}
                                  />
                              <Button type="button" className={"p-button"}
                                      onClick={() => {
                                        const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                        const currentVars = window.App.urlVars();
                                        const nextParams = new URLSearchParams();
                                        Object.entries(currentVars).forEach(([key, value]) => {
                                            if (key !== 'formData' && key !== 'createPartner') {
                                                nextParams.append(key, value);
                                            }
                                        });
                                        nextParams.append('formData', JSON.stringify(formData));
                                        nextParams.append('backlink', window.location.hash.replace('#', ''));
                                        nextParams.append('createPartner', 'true');
                                        history.push(currentPath + '?' + nextParams.toString());
                                      }}>
                                <i className={"pi pi-plus"}></i>
                              </Button>
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            {/* <div className={"p-col-12 p-lg-6"}>
              <Field name="contact" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="contact"
                          className={classNames({'p-error': isFormFieldValid(meta, 'contact')})}>{props.t('fieldContact')}</label>
                  <span className={"p-d-block"}>
                    <Dropdown
                      id="contact"
                      value={formData?.contact?.id ?? null}
                      options={contacts}
                      optionLabel="name"
                      filter
                      optionValue="id"
                      placeholder={t('selectPlaceholder')}
                      className={classNames({'p-invalid': isFormFieldValid(meta, 'contact')})}
                      onChange={(e) => {
                        const id = e.value ? Number(e.value) : null;
                        setFormData(prev => ({ ...prev, contact: id ? { id } : { id: null } }));
                        const selected = contacts.find(c => c.id === id);
                        if (selected) {
                          localStorage.setItem('defaultContactId', String(selected.id));
                          localStorage.setItem('defaultContactName', selected.name);
                        }
                      }}
                    />
                  </span>
                  {getFormErrorMessage(meta, 'contact')}
                </div>
              )}/>
            </div> */}

            <div className={"p-col-12 p-lg-4"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  <span className="p-d-block">
                      <InputSwitch 
                                //  id="active" {...input}
                                    checked={formData.active}

                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      active: e.target.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      active: e.target.value
                                    })
                                  }}
                                  value={formData.active}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'contactpartner' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        setSaveAndBack(true);
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(ContactpartnerFormComponent);
